import { constructLeaseOption } from "@at/leasing-utils";

import { LeaseOffersQuery_search_Search_advert_Advert_leasingOffers_LeaseTerms } from "../../../connected-components/hoc/query/__generated__/pdp-lease-offers.query";
import { formatAsCurrency } from "../calculator-utils";

export const getPrice = (
  selectedLeaseOffer:
    | LeaseOffersQuery_search_Search_advert_Advert_leasingOffers_LeaseTerms
    | undefined,
  leaseOption: string,
  unformattedPrice: number | null,
) => {
  if (selectedLeaseOffer) {
    const leaseOptionFromSelectedLeaseOffer = constructLeaseOption({
      depositMultiple: selectedLeaseOffer?.depositMonths ?? 0,
      numberOfMonths: selectedLeaseOffer?.termMonths ?? 0,
      mileage: selectedLeaseOffer?.totalMileage ?? 0,
    });

    if (leaseOption === leaseOptionFromSelectedLeaseOffer) {
      return formatAsCurrency(unformattedPrice);
    }
  }
  return;
};
